// extracted by mini-css-extract-plugin
module.exports = {"wireframes":"styles-module--wireframes--3K4v9","mainTitle":"styles-module--mainTitle--3vGAQ","content":"styles-module--content--2UhiB"};